import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'de_AT',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '845a84e4-0160-40c5-8c2f-4dd1eae8c588',
  ''
);
